module.exports = __webpack_public_path__ + "img/3.6632a247.png";